/**
 * 全角英数字を半角に変換
 * @param text
 * @returns
 */
export const englishNumberToHalfWidth = (text: string): string => {
  return text.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
}

/**
 * 全角カナを半角に変換
 * @param text
 * @returns
 */
export const kanaToHalfWidth = (text: string): string => {
  const kanaMap = new Map<string, string>([
    ['ガ', 'ｶﾞ'],
    ['ギ', 'ｷﾞ'],
    ['グ', 'ｸﾞ'],
    ['ゲ', 'ｹﾞ'],
    ['ゴ', 'ｺﾞ'],
    ['ザ', 'ｻﾞ'],
    ['ジ', 'ｼﾞ'],
    ['ズ', 'ｽﾞ'],
    ['ゼ', 'ｾﾞ'],
    ['ゾ', 'ｿﾞ'],
    ['ダ', 'ﾀﾞ'],
    ['ヂ', 'ﾁﾞ'],
    ['ヅ', 'ﾂﾞ'],
    ['デ', 'ﾃﾞ'],
    ['ド', 'ﾄﾞ'],
    ['バ', 'ﾊﾞ'],
    ['ビ', 'ﾋﾞ'],
    ['ブ', 'ﾌﾞ'],
    ['ベ', 'ﾍﾞ'],
    ['ボ', 'ﾎﾞ'],
    ['パ', 'ﾊﾟ'],
    ['ピ', 'ﾋﾟ'],
    ['プ', 'ﾌﾟ'],
    ['ペ', 'ﾍﾟ'],
    ['ポ', 'ﾎﾟ'],
    ['ヴ', 'ｳﾞ'],
    ['ヷ', 'ﾜﾞ'],
    ['ヺ', 'ｦﾞ'],
    ['ア', 'ｱ'],
    ['イ', 'ｲ'],
    ['ウ', 'ｳ'],
    ['エ', 'ｴ'],
    ['オ', 'ｵ'],
    ['カ', 'ｶ'],
    ['キ', 'ｷ'],
    ['ク', 'ｸ'],
    ['ケ', 'ｹ'],
    ['コ', 'ｺ'],
    ['サ', 'ｻ'],
    ['シ', 'ｼ'],
    ['ス', 'ｽ'],
    ['セ', 'ｾ'],
    ['ソ', 'ｿ'],
    ['タ', 'ﾀ'],
    ['チ', 'ﾁ'],
    ['ツ', 'ﾂ'],
    ['テ', 'ﾃ'],
    ['ト', 'ﾄ'],
    ['ナ', 'ﾅ'],
    ['ニ', 'ﾆ'],
    ['ヌ', 'ﾇ'],
    ['ネ', 'ﾈ'],
    ['ノ', 'ﾉ'],
    ['ハ', 'ﾊ'],
    ['ヒ', 'ﾋ'],
    ['フ', 'ﾌ'],
    ['ヘ', 'ﾍ'],
    ['ホ', 'ﾎ'],
    ['マ', 'ﾏ'],
    ['ミ', 'ﾐ'],
    ['ム', 'ﾑ'],
    ['メ', 'ﾒ'],
    ['モ', 'ﾓ'],
    ['ヤ', 'ﾔ'],
    ['ユ', 'ﾕ'],
    ['ヨ', 'ﾖ'],
    ['ラ', 'ﾗ'],
    ['リ', 'ﾘ'],
    ['ル', 'ﾙ'],
    ['レ', 'ﾚ'],
    ['ロ', 'ﾛ'],
    ['ワ', 'ﾜ'],
    ['ヲ', 'ｦ'],
    ['ン', 'ﾝ'],
    ['ァ', 'ｧ'],
    ['ィ', 'ｨ'],
    ['ゥ', 'ｩ'],
    ['ェ', 'ｪ'],
    ['ォ', 'ｫ'],
    ['ッ', 'ｯ'],
    ['ャ', 'ｬ'],
    ['ュ', 'ｭ'],
    ['ョ', 'ｮ'],
    ['。', '｡'],
    ['、', '､'],
    ['ー', 'ｰ'],
    ['「', '｢'],
    ['」', '｣'],
    ['・', '･'],
    ['　', ' '],
  ])
  const reg = new RegExp('(' + Array.from(kanaMap.keys()).join('|') + ')', 'g')
  return text.replace(reg, (s: string) => kanaMap.get(s) ?? s)
}

/**
 * 全角記号を半角に変換
 * @param text
 * @returns
 */
export const symbolToHalfWidth = (text: string): string => {
  return text.replace(/[！-／：-＠［-｀｛-～]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
}

/**
 * 半角文字に変換
 * @param text
 * @param whiteSpace `trim`=半角スペースをトリム(前後スペースと連続する空白の削除)、`all-trim`=空白をすべて削除
 * @returns
 */
export const toHalfWidth = (text: string, whiteSpace: 'trim' | 'all-trim' = 'trim'): string => {
  const optimized1 = englishNumberToHalfWidth(text)
  const optimized2 = kanaToHalfWidth(optimized1)
  const optimized3 = symbolToHalfWidth(optimized2)
  if (whiteSpace === 'all-trim') {
    return optimized3.replace(/[\s]+/g, '')
  } else {
    return optimized3.trim().replace(/[\s]+/g, ' ')
  }
}
